import React from "react";
import voyagesecc from "../assets/images/voyagesecc.png";

const VoyageSection = () => {
  return (
    <section id="b2b" className="md:scroll-mt-24 md:mb-24 relative mx-auto w-full max-w-7xl overflow-hidden rounded-2xl border border-[#E5EEF2] bg-[#F7FBFD] shadow-[0_20px_60px_rgba(18,52,74,0.08)]">

      {/* Subtle decorative background */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-56 w-56 rounded-full bg-[#97BF49]/10 blur-3xl"></div>

      <div className="pointer-events-none absolute -bottom-24 -right-24 h-56 w-56 rounded-full bg-[#019EE7]/10 blur-3xl"></div>

      <div className="relative flex flex-wrap ">

        {/* LEFT CONTENT */}
        

        {/* RIGHT FULL HEIGHT IMAGE */}
        <div className="group relative  overflow-hidden  md:w-6/12">
<div className="flex justify-center mx-auto">
          <img
            src={voyagesecc}
            alt="Voyage Plus Travel services"
            className="pt-4  transition-transform duration-700 ease-out group-hover:scale-[1.03] h-[600px] "
          />
</div>
          {/* Subtle image overlay */}
          {/* <div className="absolute inset-0 bg-[#12344A]/[0.04] transition-all duration-500 group-hover:bg-transparent"></div> */}

          {/* Image edge highlight */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-px bg-white/50"></div>

        </div>

        <div className="relative flex flex-col justify-center px-6 py-12 sm:px-10 md:w-6/12 md:px-0 lg:px-0 lg:py-16">

          {/* Small heading */}
          <div className="mb-5 flex items-center gap-3">

            <span className="text-base font-bold tracking-[0.2em] text-sky-800">
              B2B Travel Engine
            </span>
          </div>

          {/* Heading */}
          <h1 className="m-0 text-[25px] font-bold leading-[1.05] tracking-[-0.2px] text-[#12344A] sm:text-[48px] lg:text-[58px]">
            Voyage Plus Travel
            <br />
            <span className="text-[#10233b]">
              provides access to
            </span>
          </h1>

          {/* Description */}
          <p className="mt-5 max-w-[570px] text-[14px] leading-[1.55] text-[#536B7A] sm:text-[15px] lg:text-[16px]">
            its online booking platform, “Voyage HUB” throughwhich authorized
            users may access travel services including Airline bookings and
            ticketing services, hotel reservations, holiday packages and other
            travel-related solutions. The platform is designed to deliver a
            seamless, efficient, and user-friendly bookingexperience, enabling
            clients to manage all travel requirements through a single portal.
          </p>

          {/* CTA */}
          <div className="mt-8">
            <a
              href= "https://voyagehub.me/" target="_blank"
              className="group inline-flex items-center gap-4 rounded-lg bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-6 py-3 text-[13px] font-bold tracking-[0.6px] text-white shadow-[0_10px_25px_rgba(1,158,231,0.20)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#12344A] hover:shadow-[0_15px_30px_rgba(18,52,74,0.20)]"
            >
              <span>Explore Voyage HUB</span>

              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-white/15 transition-all duration-300 group-hover:translate-x-1">
                <i className="las la-arrow-right text-[16px]" />
              </span>
            </a>
           
          </div>

          {/* Premium feature cards */}
          {/* <div className="mt-10 grid max-w-[500px] grid-cols-2 gap-3"> */}

            {/* Feature 1 */}
            {/* <div className="group rounded-xl border border-[#DCE8EE] bg-white/75 px-4 py-4 shadow-[0_4px_18px_rgba(18,52,74,0.04)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#97BF49]/50 hover:shadow-[0_10px_25px_rgba(18,52,74,0.08)]">

              <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-lg bg-[#97BF49]/15 transition-all duration-300 group-hover:bg-[#97BF49]/25">
                <i className="las la-layer-group text-lg text-[#6F9F25]"></i>
              </div>

              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#7A909D]">
                One platform
              </p>

              <p className="mt-1 text-sm font-bold leading-snug text-[#12344A]">
                Multiple travel solutions
              </p>
            </div> */}

            {/* Feature 2 */}
            {/* <div className="group rounded-xl border border-[#DCE8EE] bg-white/75 px-4 py-4 shadow-[0_4px_18px_rgba(18,52,74,0.04)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#019EE7]/40 hover:shadow-[0_10px_25px_rgba(18,52,74,0.08)]">

              <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-lg bg-[#019EE7]/10 transition-all duration-300 group-hover:bg-[#019EE7]/15">
                <i className="las la-mouse-pointer text-lg text-[#019EE7]"></i>
              </div>

              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#7A909D]">
                Simple
              </p>

              <p className="mt-1 text-sm font-bold leading-snug text-[#12344A]">
                Seamless booking
              </p>
            </div> */}

          {/* </div> */}
        </div>

      </div>
    </section>
  );
};

export default VoyageSection;